















import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import VatsAPI from '@/Shared/VatsAPI';

const retryCount = 3;

// For dumb reasons, we must wait for PayPal's payment to be completed in our system
// Even after the user has navigated back to our site
// This component calls an endpoint that waits for the completion and then directs
// us to the normal completion page.
const component = mixins(LocationBasedMixin).extend({
    props: {
        transactionId: {
            type: String,
            required: true,
        },
        completionRouteName: {
            type: String,
            required: true,
        }
    },
    beforeMount() {
        this.awaitCompletion();
    },
    data() {
        return {
            i18nPrefix: 'payment.paypalCompletion',
            loading: false,
            error: false,
        };
    },
    computed: {
        pollUrl(): string {
            return `${this.location}/Payments/IsCompleted`;
        }
    },
    methods: {
        async poll() {
            const result = await VatsAPI.get<string>(this.pollUrl, {
                headers: {
                    accept: 'application/json',
                },
                params: {
                    transactionId: this.transactionId,
                    waitCount: 20
                }
            });

            return result;
        },
        async awaitCompletion() {
            this.loading = true;
            let result = null;
            let success = false;

            for (let i = 0; i < retryCount && !success; i++) {
                try {
                    result = await this.poll();
                    success = true;
                }
                catch (e) {
                    success = false;
                }
            }

            this.loading = false;

            if (success) {
                await this.$router.push({
                    name: this.completionRouteName,
                    params: { responseId: result!.data as any }
                });
            }
            else {
                this.error = true;
            }
        }
    }
});

export default component;
